<template>
	<div>
		<h1>{{ value.values.value }} <small v-html="units"></small></h1>
		<!--p class="row">
			<b>{{ $t('labels.general.value') }}</b>
			<span>{{ value.values.value }} <span v-html="units"></span></span>
		</p-->
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'value'
	],
	computed: {
		units () {
			return Readings.readingTypes.get(parseInt(this.value.type_id)).unitHtml
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/widgets/modal/ModalBoxBiometricPedometer.vue